import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Features', href: '#features' },
    { label: 'Workflow', href: '#workflow' },
    { label: 'FAQ', href: '#faq' },
    { label: 'Contact', href: '#concierge' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
        isScrolled 
          ? 'bg-[#000000]/90 backdrop-blur-lg border-b border-white/10 py-3' 
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-[7.6923%]">
        <div className="flex items-center justify-between h-14 md:h-16">
          {/* Logo Section */}
          <a href="#" className="flex items-center gap-3 group shrink-0">
            <div className="w-9 h-9 md:w-10 md:h-10 bg-[#00FFD1] flex items-center justify-center transition-transform duration-300 group-hover:scale-105 rounded-sm">
              <span className="text-black font-bold text-lg md:text-xl">RL</span>
            </div>
            {/* INLINE STYLE FIX ADDED BELOW */}
            <span 
              className="font-bold text-lg md:text-xl tracking-tight"
              style={{ color: '#00FFD1' }} 
            >
              Ruma Logistics
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-white/60 hover:text-[#00FFD1] text-sm lg:text-base font-medium transition-colors duration-300"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA Button */}
          <div className="hidden md:flex items-center">
            <a
              href="#concierge"
              className="bg-[#00FFD1] text-black px-6 py-2.5 font-bold text-sm transition-all duration-400 hover:bg-[#00FFD1]/20 hover:text-[#00FFD1] border border-[#00FFD1]"
            >
              Request Demo
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2 -mr-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-[#0a0a0a]/98 backdrop-blur-xl border-b border-white/10 transition-all duration-300 ease-in-out ${
          isMobileMenuOpen 
            ? 'opacity-100 translate-y-0 visible' 
            : 'opacity-0 -translate-y-4 invisible'
        }`}
      >
        <nav className="flex flex-col p-6 pb-10 gap-2">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-white/70 hover:text-[#00FFD1] text-xl font-semibold py-4 border-b border-white/5 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#concierge"
            className="bg-[#00FFD1] text-black px-6 py-4 font-bold text-lg text-center mt-6 rounded-sm"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Request Free Demo
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;